<template>
    <m-assembly-table
        :formData="formData"
        :columns="tableColumns"
        :data="tableData"
        :currentPage="settings.currentPage"
        :pageSize="settings.pageSize"
        :settings="settings"
        :tableButtons="tableButtons"
        :loading="loading"
        :total="settings.total"
        @onSubmit="onSubmit"
        @onPageSizeChange="onPageSizeChange"
        @onCurrentPageChange="onPageChange"
        @onSelectionChange="onSelectionChange"
        ref="pageForm">
    </m-assembly-table>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import axios from 'axios';
import { exportExcel } from '@/utils/tool';
import moment from 'moment';

export default {
    name: 'TMRollingForecast',
    components: {
        mAssemblyTable,
    },
    data() {
        const { userId = '' } = this.getVendorInfo();
        return {
            userId,
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'organizationId',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('TMRollingForecast.t1'),
                            },
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        methods: {
                            change: (val) => {
                                if (val) {
                                    this.getVersionNum(val);
                                }
                            },
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('TMRollingForecast.t2'), // 库存组织
                    },
                    {
                        value: '',
                        field: 'versionNumber',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('TMRollingForecast.t3'), // 版本号
                    },
                    {
                        value: '',
                        field: 'demandDate',
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'month',
                            format: 'yyyyMM',
                            needFormat: false,
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('TMRollingForecast.t4'), // 需求月份
                    },
                    {
                        value: '',
                        field: 'itemCode',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('TMRollingForecast.t5'), // 物料编码
                    },
                    {
                        value: '',
                        field: 'buyerName',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('TMRollingForecast.t6'), // 采购员
                    },
                    {
                        value: '',
                        field: 'status',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: this.$t('TMRollingForecast.t30'), // 已确认
                                    value: 'A',
                                },
                                {
                                    label: this.$t('TMRollingForecast.t31'), // 未确认
                                    value: 'S',
                                },
                                {
                                    label: this.$t('TMRollingForecast.t32'), // 拒绝
                                    value: 'R',
                                },
                            ],
                        },
                        type: 'select',
                        title: this.$t('TMRollingForecast.t7'), // 反馈状态
                    },
                    {
                        value: '',
                        field: 'zyFlag',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            multiple: false,
                            values: [
                                {
                                    label: this.$t('TMRollingForecast.t9'), // 全部
                                    value: '',
                                },
                                {
                                    label: this.$t('TMRollingForecast.t10'), // 是
                                    value: 'Y',
                                },
                                {
                                    label: this.$t('TMRollingForecast.t11'), // 否
                                    value: 'N',
                                },
                            ],
                        },
                        type: 'select',
                        title: this.$t('TMRollingForecast.t8'), // 是否专用
                    },
                    {
                        value: true,
                        field: 'queryLatest',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2,
                        },
                        type: 'checkbox',
                        trueValue: true,
                        falseValue: false,
                        title: this.$t('TMRollingForecast.t33'), // 最新版本
                    },
                ],
            },
            tableColumns: {
                columns: [
                    {
                        type: 'selection',
                        align: 'center',
                        width: 35,
                    },
                    {
                        title: this.$t('TMRollingForecast.t2'), // 库存组织
                        key: 'ORGANIZATIONCODE',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('TMRollingForecast.t3'), // 版本号
                        key: 'VERSIONNUMBER',
                        align: 'center',
                        width: 110,
                    },
                    {
                        title: this.$t('TMRollingForecast.t12'), // 版本
                        key: 'MONTHVERSION',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('TMRollingForecast.t13'), // 预测月份
                        key: 'FORECASTDATE',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('TMRollingForecast.t5'), // 物料编码
                        key: 'ITEMCODE',
                        align: 'center',
                        width: 110,
                    },
                    {
                        title: this.$t('TMRollingForecast.t14'), // 物料说明
                        key: 'ITEMDESCRIPTIONS',
                        width: 200,
                        tooltip: true,
                    },
                    {
                        title: this.$t('TMRollingForecast.t15'), // 采购周期
                        key: 'PROCESSINGLEADTIME',
                        width: 100,
                    },
                    {
                        title: this.$t('TMRollingForecast.t6'), // 采购员
                        key: 'BUYERNAME',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('TMRollingForecast.t4'), // 需求月份
                        key: 'DEMANDDATE',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('TMRollingForecast.t16'), // 状态
                        key: 'NSTATUS',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('TMRollingForecast.t17'), // 发布日期
                        key: 'PUBLISHDATE',
                        align: 'center',
                        width: 110,
                    },
                    {
                        title: this.$t('TMRollingForecast.t18'), // 预测总量
                        key: 'FCSTQUANTITY',
                        align: 'center',
                        width: 90,
                    },
                    {
                        title: this.$t('TMRollingForecast.t19'), // 上版备料量
                        key: 'PREQUANTITYALLOTTED',
                        align: 'center',
                        width: 100,
                    },
                    {
                        title: this.$t('TMRollingForecast.t20'), // 差异量
                        key: 'DIFFQTYS',
                        align: 'center',
                        width: 90,
                        render: (h, params) => {
                            const { DIFFQTYS } = params.row;
                            return h('div', {
                                style: {
                                    background: DIFFQTYS > 0 ? '#CCE8CF' : (DIFFQTYS === 0 ? '' : '#FFC0CB')
                                },
                            }, DIFFQTYS);
                        },
                    },
                    {
                        title: this.$t('TMRollingForecast.t21'), // 是否接受
                        key: 'ENABLEDFLAG',
                        align: 'center',
                        width: 120,
                        render: (h, params) => {
                            if (params.row.STATUS === 'S') {
                                return h('RadioGroup', {
                                    props: {
                                        vertical: false,
                                        value: params.row.ENABLEDFLAG,
                                    },
                                    on: {
                                        'on-change': (val) => {
                                            if (val === 'Y') {
                                                params.row.FEEDBACKCOMMENTS = '';
                                            }
                                            params.row.ENABLEDFLAG = val;
                                            this.tableData[params.index] = params.row;
                                        },
                                    },
                                }, [h('Radio', {
                                    props: {
                                        label: 'Y',
                                    },
                                }, this.$t('TMRollingForecast.t10')), h('Radio', {
                                    props: {
                                        label: 'N',
                                    },
                                }, this.$t('TMRollingForecast.t11'))]);
                            } else {
                                return h('div');
                            }
                        },
                    },
                    {
                        title: this.$t('TMRollingForecast.t22'), // 拒绝原因
                        key: 'FEEDBACKCOMMENTS',
                        align: 'center',
                        width: 130,
                        render: (h, params) => {
                            if (params.row.STATUS === 'S') {
                                return h('Input', {
                                    props: {
                                        size: 'small',
                                        value: params.row.FEEDBACKCOMMENTS,
                                        disabled: params.row.ENABLEDFLAG === 'Y',
                                    },
                                    on: {
                                        'on-change': (event) => {
                                            params.row.FEEDBACKCOMMENTS = event.target.value;
                                            this.tableData[params.index] = params.row;
                                        },
                                    },
                                });
                            } else {
                                return h('div', params.row.FEEDBACKCOMMENTS);
                            }
                        },
                    },
                    {
                        title: this.$t('TMRollingForecast.t23'), // 反馈日期
                        key: 'FEEDBACKDATE',
                        align: 'center',
                        width: 180,
                    },
                    {
                        title: this.$t('TMRollingForecast.t8'), // 是否专用
                        key: 'ZY_FLAG',
                        width: 60,
                        align: 'center',
                        render: (h, params) => {
                            return h('span', params.row.ZYFLAG === 'Y' ? '是' : '否');
                        },
                    },
                ],
            },
            tableData: [],
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('TMRollingForecast.t24'), // 提交
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        click: (button) => {
                            this.handleSave(button);
                        },
                    },
                    {
                        label: this.$t('TMRollingForecast.t25'), // 导出
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        click: (button) => {
                            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                const params = {
                                    vendorCode: this.vendorCode,
                                    ...this.getFormDataVModel(this.formData.items),
                                };
                                button.loading = true;
                                exportExcel(`/gscint/plannedOrder/MarchFeedback/exportxls?paraJson=${encodeURI(JSON.stringify(params))}&language=${this.language}`, {}, `${this.$t('route.TMRollingForecast') + moment().format('YYYY-MM-DD')}.xlsx`, this)
                                    .finally(() => {
                                        button.loading = false;
                                    });
                            }
                        },
                    },
                    {
                        name: '',
                        label: this.$t('TMRollingForecast.t26'), // 全部接受
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        disabled: () => this.selection.length === 0,
                        click: (button) => {
                            this.$Modal.confirm({
                                content: this.$t('TMRollingForecast.t27'), // 当前数据会默认全部接受，是否确认？
                                onOk: () => {
                                    this.confirmAll(button);
                                },
                            });
                        },
                    },
                ],
            },
            loading: false,
            selection: [],
            orgList: [],
        };
    },
    methods: {
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        /** 页容量改变时触发 */
        onPageSizeChange(currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSubmit(current, pageSize, condition) {
            this.condition = condition;
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSelectionChange(selection) {
            this.selection = selection;
        },
        onSearch() {
            this.loading = true;
            const { currentPage: page, pageSize } = this.settings;
            axios.get('/gscint/plannedOrder/MarchFeedback/findMarchFeedbackDetail', {
                params: {
                    vendorCode: this.vendorCode,
                    page,
                    pageSize,
                    ...this.getFormDataVModel(this.formData.items),
                },
            })
                .then((res) => {
                    const { success, data } = res.data;
                    if (success) {
                        const { list, total } = data;
                        list.map((item) => {
                            item.ENABLEDFLAG = 'Y';
                        });
                        this.tableData = list;
                        this.settings.total = total;
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getOrgList() {
            axios.get('/gscint/vendor/getSRMInvLovListNew?SITE=Y')
                .then((res) => {
                    const list = res.data.data.map((item) => {
                        return {
                            ...item,
                            label: item.organizationName,
                            value: item.erpOrgId,
                        };
                    });
                    this.orgList = list;
                    this.getFormDataItemObj(this.formData.items, 'organizationId').options.values = list;
                });
        },
        getOrgCode(erpOrgId) {
            return this.orgList.find((item) => item.value === erpOrgId).organizationCode;
        },
        /* 获取版本号 */
        getVersionNum(organizationId) {
            axios.get('/gscint/plannedOrder/MarchFeedback/getVersionNum', {
                params: {
                    vendorCode: this.vendorCode,
                    organizationId,
                    orgCode: this.getOrgCode(organizationId),
                },
            })
                .then((res) => {
                    const versionNumber = this.getFormDataItemObj(this.formData.items, 'versionNumber');
                    const { data } = res.data;
                    if (data) {
                        const list = data.map((item) => {
                            return {
                                label: item.versionNumber,
                                value: item.versionNumber,
                            };
                        });
                        versionNumber.options.values = list;
                        if (list > 0) {
                            versionNumber.value = list[0].value;
                        }
                    }
                });
        },
        /* 保存 */
        handleSave(button) {
            const selection = this.$refs.pageForm.getSelection();
            if (selection.some((item) => item.ENABLEDFLAG === 'N' && !item.FEEDBACKCOMMENTS)) {
                this.$Modal.warning({
                    content: this.$t('TMRollingForecast.t28'), // 请填写拒绝原因
                });
            } else {
                button.loading = true;
                axios.post('/gscint/plannedOrder/MarchFeedback/saveMarchFeedbackDetail', selection.map(( { COLLECTID: collectId, FEEDBACKCOMMENTS: feedbackComments, ENABLEDFLAG: enabledFlag } ) => {
                    return {
                        collectId,
                        feedbackComments,
                        enabledFlag,
                        vendorId: this.userId,
                        vendorCode: this.vendorCode,
                    };
                }))
                    .then((res) => {
                        const { success, msg: content } = res.data;
                        if (success) {
                            this.$Modal.success({
                                content: this.$t('TMRollingForecast.t29'),
                            });
                            this.onSearch();
                        } else {
                            this.$Modal.warning({
                                content,
                            });
                        }
                    })
                    .catch(() => {
                        this.showErrorTips();
                    })
                    .finally(() => {
                        button.loading = false;
                    });
            }
        },
        /* 全部接受 */
        confirmAll(button) {
            button.loading = false;
            axios.post('/gscint/plannedOrder/MarchFeedback/queryMarchFeedbackDetail', {
                vendorCode: this.vendorCode,
                ...this.getFormDataVModel(this.formData.items),
            })
                .then((res) => {
                    const { success, msg: content } = res.data;
                    if (success) {
                        this.$Modal.success({
                            content: this.$t('TMRollingForecast.t29'),
                        });
                        this.onSearch();
                    } else {
                        this.$Modal.warning({
                            content,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                })
                .finally(() => {
                    button.loading = false;
                });
        },
    },
    mounted() {
        this.getOrgList();
    },
};
</script>
